import Content from "./content";
import { store } from "~/state/store";
import { isFirmFromPoi } from "~/util/review";
import { parsePhone } from "~/util/detail";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

const SVG = {
	phone: "phone",
	email: "envelope",
	www: "globe",
	firmy: "firmy",
	dashboard: "firmy-logo",
};
const CHEVRON = {
	telefon: "",
	mobil: "",
	tel: "",
	recepce: _("contacts.reception"),
	// eslint-disable-next-line quote-props
	"kancelář": _("contacts.office"),
	kancelar: _("contacts.office"),
	prodejna: _("contacts.shop"),
};

export default class Contact extends Content {
	_build() {
		this._dom.container.classList.add("content-contact");

		// 1) telefon 2) email 3) web 4) firmy
		["phone", "email", "www", "firmy"].forEach(type => {
			let data = this._data[type];

			// pokud nemame telefon, ale potrebujeme rict, ze kontakty si majitel nepral zverejnit, nafakeujeme ho
			if (!data && (type === "phone" && this._options.noContact)) {
				data = {
					value: [1],
				};
			}

			if (data) {
				const el = node("div");

				el.classList.add("contact-container");
				el.classList.add(type);
				el.appendChild(icon(SVG[type]));
				const list = node("ul");

				data.value.forEach((record, ind) => {
					const item = node("li", { textContent: "" });
					const cfg: {
						dropdown: boolean;
						parent: HTMLUListElement;
						listItem: HTMLLIElement;
						type: string;
						value?: string;
						chevron?: string;
						link?: string;
						linkTarget?: string;
					} = {
						dropdown: ind === 0 && data.value.length > 1,
						parent: list,
						listItem: item,
						type,
					};

					switch (type) {
						case "phone": {
							if (this._options.noContact) {
								cfg.value = _("detail.content.nocontact");
								el.classList.add("nocontact");
							} else {
								const phoneData = parsePhone(record);

								cfg.value = phoneData.number;
								cfg.chevron = record.type || "";

								if (Mapy.Util.isMobile()) {
									cfg.link = `tel: ${phoneData.wholeNumber}`;
								}
							}
						}
							break;
						case "report":
							cfg.value = _("report.suggestEditData");
							break;
						case "email": {
							cfg.value = record;
							cfg.link = `mailto:${record}`;
						}
							break;

						case "www": {
							cfg.value = this._getLinkTxt(record);
							cfg.link = record.url;
							cfg.linkTarget = "_blank";

							// pro dlouhe url
							if (cfg.value.length > 35) {
								item.classList.add("long-link");
							}
						}
							break;

						case "firmy": {
							cfg.value = _("detail.content.review2.ownCompany");
							let lang = "";

							if (["cs", "sk"].indexOf(CONFIG.defaultLang) === -1) {
								lang = "&lang=en";
							}
							cfg.link = `${record}?source=mapy${lang}`;
							cfg.linkTarget = "_blank";
						}

							break;
						default:
					}

					const createdEl = this._createItem(cfg);

					if (type === "firmy") {
						createdEl.setAttribute("data-log-ignore", "");
						createdEl.addEventListener("click", evnt => {
							const state = store.getState();
							const { user } = state.user;
							const { data: detailData } = state.detail;

							// analytika
							if (detailData) {
								Mapy.getComponent("logger").log("click", {
									text: "Je toto vaše firma?",
									source: detailData.source,
									id: detailData.id,
									typeId: detailData.typeId,
									name: detailData.title,
								});
							}

							if (user.state !== "green") {
								evnt.preventDefault();
								evnt.stopPropagation();
								Mapy.getComponent("login").open({
									analyticsData: {
										loginOrigin: "claimPoi",
									},
									motivation: "common",
								}).then(() => {
									createdEl.click();
								}, () => {});
							}
						});
					} else if (type === "www") {
						createdEl.addEventListener("click", event => {
							event.preventDefault();

							const timeout = setTimeout(() => {
								window.open(cfg.link);
							}, 300);

							fetch(`https://${CONFIG.BASE_DOMAIN}/decorate`, {
								headers: {
									"Accept": "application/json",
									"Content-Type": "application/json",
								},
								credentials: "include",
								method: "POST",
								body: `["${cfg.link}"]`,
							}).then(response => {
								response.json().then(link => {
									if (link.length) {
										window.open(link[0]);
									}

									clearTimeout(timeout);
								});
							}, () => {
								window.open(cfg.link);

								clearTimeout(timeout);
							});
						});
					}

					item.appendChild(createdEl);
					list.appendChild(item);
				});
				el.appendChild(list);
				this._dom.container.appendChild(el);
			}
		});
	}

	_getLinkTxt(data) {
		if (isFirmFromPoi(this._options)) {
			return data.text || data.url;
		}
		let linkTxt = "";

		if (data.text) {
			linkTxt = data.text;
		} else if (data.url) {
			// eslint-disable-next-line require-unicode-regexp
			const match = data.url.match(/\/\/([^/?#]+)/);

			linkTxt = match && match.length >= 2 ? match[1] : data.url;
		}

		return linkTxt;
	}

	_createItem(optsArg) {
		const opts = {
			value: "",
			link: "",
			linkTarget: "",
			chevron: "",
			dropdown: false,
			listItem: null,
			parent: null,
			type: "",
			...optsArg,
		};

		const el = node(opts.link ? "a" : "span", { className: opts.type || "", innerHTML: opts.value });

		if (opts.link) {
			(el as HTMLAnchorElement).href = opts.link;
			// analytika
			el.addEventListener("pointerdown", () => {
				const { data } = store.getState().detail;

				switch (opts.type) {
					case "phone":
						Mapy.getComponent("detail").sendFirmStats("phone", data, { placeId: 1, typeId: 6 });
						break;

					case "email":
						Mapy.getComponent("detail").sendFirmStats("mail", data, { placeId: 1, typeId: 2 });
						break;

					case "www":
						Mapy.getComponent("detail").sendFirmStats("www", data, { placeId: 1, typeId: 1 });
						break;

					default:
				}
			});
		}
		if (opts.linkTarget) {
			el.setAttribute("target", opts.linkTarget);
		}
		// pouze pro firmy
		if (opts.chevron && isFirmFromPoi(this._options)) {
			// dame na male pismenka
			const chevron = opts.chevron.toLowerCase();
			// zkusime najit typ, jestli to sedi
			let value = "";

			if (chevron in CHEVRON) {
				value = CHEVRON[chevron];
			} else if (CONFIG.defaultLang === "cs") {
				value = opts.chevron;
			}

			if (value) {
				el.appendChild(node("span", { className: "chevron", textContent: value }));
			}
		}
		if (opts.dropdown) {
			el.appendChild(icon("dropdown"));
			el.appendChild(icon("dropup"));
			opts.listItem.addEventListener("click", evnt => {
				opts.parent.classList.toggle("open");

				const elName = evnt.target.nodeName.toLowerCase();

				if (elName !== "a") {
					evnt.preventDefault();
					evnt.stopPropagation();
				}
			});
		}

		return el;
	}
}
